/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServicePriceDto
 */
export interface ServicePriceDto {
    /**
     * The label of the price.
     * @type {string}
     * @memberof ServicePriceDto
     */
    label: string;
    /**
     * The target value.
     * @type {string}
     * @memberof ServicePriceDto
     */
    target: string;
    /**
     * The test value.
     * @type {string}
     * @memberof ServicePriceDto
     */
    test: string;
    /**
     * The price per hour in the currency of the service.
     * @type {number}
     * @memberof ServicePriceDto
     */
    pricePerHour: number;
}

/**
 * Check if a given object implements the ServicePriceDto interface.
 */
export function instanceOfServicePriceDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "target" in value;
    isInstance = isInstance && "test" in value;
    isInstance = isInstance && "pricePerHour" in value;

    return isInstance;
}

export function ServicePriceDtoFromJSON(json: any): ServicePriceDto {
    return ServicePriceDtoFromJSONTyped(json, false);
}

export function ServicePriceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServicePriceDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': json['label'],
        'target': json['target'],
        'test': json['test'],
        'pricePerHour': json['pricePerHour'],
    };
}

export function ServicePriceDtoToJSON(value?: ServicePriceDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
        'target': value.target,
        'test': value.test,
        'pricePerHour': value.pricePerHour,
    };
}

